import { Box, Flex, Text } from '@radix-ui/themes';

const DraggedGoal = ({ goal, currentTargetPosition }) => {
  if (!goal) return null;

  const goalNumber =
    currentTargetPosition?.targetIndex + 1 || goal.originalIndex + 1;

  return (
    <Box
      style={{
        backgroundColor: 'var(--color-panel)',
        borderRadius: 'var(--radius-3)',
        boxShadow: 'var(--shadow-4)',
        height: '55px',
      }}
      p="2"
    >
      <Flex align="center" gap="3" width="100%" style={{ height: '100%' }}>
        <Box
          w="2"
          style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}
          ml="2"
          mr="4"
        >
          <i
            className="fa-thin fa-grip-vertical"
            style={{ color: 'var(--gray-9)', fontSize: '12px' }}
          />
        </Box>

        <Flex align="center" gap="2" style={{ flex: 1, alignItems: 'center' }}>
          <Text size="2" weight="bold" style={{ lineHeight: 1 }}>
            {goalNumber}.
          </Text>
          <Text size="2" style={{ lineHeight: 1 }}>
            {goal.goal}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default DraggedGoal;
